import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BaseService } from './base-service.service';
import { SpinnerService } from './spinner.service';

@Injectable({
  providedIn: 'root'
})
export class DownloadFilesService extends BaseService {
  constructor(private spinnerService: SpinnerService, private http: HttpClient) { super(); }

  downloadFieldsClassificationXlsx() {
    this.spinnerService.setTrue();
    return this.http.get(`${this.getUrl('Analytics/DownloadFieldsClassificationXlsx')}`, { responseType: 'blob' })
      .subscribe(response => this.downloadFile(response, 'Campos.Xlsx'));
  }

  downloadSalesDTAXlsx() {
    this.spinnerService.setTrue();
    return this.http.get(`${this.getUrl('Analytics/DownloadSalesDTAXlsx')}`, { responseType: 'blob' })
      .subscribe(response => this.downloadFile(response, 'VentasDTA.Xlsx'));
  }

  downloadPolygonKMZ(id: number, fieldName: string) {
    this.spinnerService.setTrue();
    return this.http.get(`${this.getUrl('fields/polygon/export')}/${id}`, { responseType: 'blob' })
      .subscribe(response => this.downloadFile(response, `${fieldName}.kmz`));
  }

  downloadAllPolygonsKMZ() {
    this.spinnerService.setTrue();
    return this.http.get(`${this.getUrl('fields/polygons/export')}`, { responseType: 'blob' })
      .subscribe(response => this.downloadFile(response, 'campos.kmz'));
  }

  private downloadFile(blob: any, filename: string): string {
    this.spinnerService.setFalse();
    const url = window.URL.createObjectURL(blob); // <-- work with blob directly

    // create hidden dom element (so it works in all browsers)
    const a = document.createElement('a');
    a.setAttribute('style', 'display:none;');
    document.body.appendChild(a);

    // create file, attach to hidden element and open hidden element
    a.href = url;
    a.download = filename;
    a.click();
    return url;
  }
}
